
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Bestweddingcarrentalinmumbai() {



    const cardData =
    {
        keyword: ' Best Wedding Car Rental in Mumbai',
        heading: 'Vedant Travels: Best Wedding Car Rental in Mumbai',
        headingDescription: 'Make your wedding day grand and memorable with Vedant Travels premium wedding car rental services in Mumbai. We offer a luxurious fleet of sedans, SUVs, vintage cars, and premium limousines to ensure a stylish and comfortable ride for the bride, groom, and guests. Whether you need a classic Rolls-Royce, an elegant Mercedes-Benz, or a spacious Innova Crysta, we provide well-maintained vehicles with professional chauffeurs for a hassle-free experience.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The Gateway of India is Mumbai’s most famous landmark, built in 1924 overlooking the Arabian Sea. It’s a perfect spot for photography and boat rides to Elephanta Caves."
    },
    {
        "title": "Marine Drive",
        "description": "Also known as the 'Queen’s Necklace,' Marine Drive is a picturesque boulevard along the Arabian Sea. Enjoy the cool breeze, stunning sunset views, and a relaxing stroll."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A UNESCO World Heritage Site, this historic railway station is an architectural marvel blending Victorian Gothic and Indian styles."
    },
    {
        "title": "Juhu Beach",
        "description": "Juhu Beach is famous for its lively atmosphere, street food, and beautiful sunset views. Try the iconic Mumbai street food like pav bhaji and vada pav here."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, these UNESCO-listed rock-cut caves feature ancient sculptures of Lord Shiva and are a must-visit for history lovers."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "One of Mumbai’s most revered temples, dedicated to Lord Ganesha. Devotees from all over the country visit to seek blessings."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "A stunning mosque located on an islet in the Arabian Sea, connected by a narrow walkway. It’s a significant spiritual and architectural attraction."
    },
    {
        "title": "Colaba Causeway",
        "description": "A paradise for shoppers, Colaba Causeway is known for trendy clothes, accessories, antiques, and cafés. Don’t miss the iconic Leopold Café."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "A modern engineering marvel, this bridge connects Bandra and Worli, offering stunning views of Mumbai’s skyline, especially at night."
    },
    {
        "title": "Sanjay Gandhi National Park & Kanheri Caves",
        "description": "A green escape within the city, this national park is home to leopards, nature trails, and the ancient Buddhist Kanheri Caves."
    }
],

"services": [
    {
        "name": "Best Wedding Car Rental in Mumbai with Vedant Travels",
        "description": "Make your wedding day even more special with Vedant Travels' best wedding car rental service in Mumbai. We offer a variety of luxury and comfortable vehicles to suit your wedding theme and style, ensuring you make a grand entrance on your special day."
    },
    {
        "name": "Wedding Car Hire in Mumbai",
        "description": "Looking for a beautiful car to hire for your wedding? Vedant Travels offers a wide selection of wedding car hire options in Mumbai, from classic cars to luxury limousines. Choose the perfect vehicle to add elegance and style to your wedding day."
    },
    {
        "name": "Mumbai Wedding Car Service",
        "description": "Ensure a seamless and luxurious travel experience on your wedding day with Vedant Travels' Mumbai wedding car service. Our professional chauffeurs and premium vehicles provide you with the comfort and reliability you need to make your wedding day truly unforgettable."
    },
    {
        "name": "Mumbai Wedding Limo Rental",
        "description": "For a touch of luxury, rent a wedding limo in Mumbai from Vedant Travels. Our wedding limo rentals are designed for style and comfort, providing you with an unforgettable ride to and from your wedding venue. Experience elegance and sophistication on your big day."
    },
    {
        "name": "Luxury Wedding Car Rental in Mumbai",
        "description": "Make your wedding day luxurious and memorable with Vedant Travels' luxury wedding car rental service. We offer top-tier vehicles like the Mercedes Benz, BMW, and more to ensure that you travel in comfort and style. Trust us to provide the best for your wedding day."
    },
    {
        "name": "Wedding Car Booking in Mumbai",
        "description": "Booking a wedding car in Mumbai is easy with Vedant Travels. Whether you need a vehicle for the bride, groom, or guests, we offer a variety of options for booking wedding cars. Get in touch with us to secure your wedding car for a hassle-free experience."
    },
    {
        "name": "Wedding Car Rental Packages in Mumbai",
        "description": "Vedant Travels offers custom wedding car rental packages in Mumbai to suit your needs. Whether you require a car for a few hours or the entire day, we have a package that fits your requirements and budget. Contact us to choose the best package for your wedding day."
    },
    {
        "name": "Mumbai Wedding Car Booking",
        "description": "Secure your wedding car with Vedant Travels in Mumbai. Our seamless booking process ensures you get the perfect car for your wedding day. Let us take care of your transportation needs so you can focus on enjoying your special day."
    },
    {
        "name": "Wedding Car for Rent in Mumbai",
        "description": "Vedant Travels offers a wide selection of wedding cars for rent in Mumbai. From luxurious sedans to elegant limos, we have the perfect vehicle to suit your wedding style. Rent your wedding car with us for a stress-free and beautiful wedding day."
    }
],



"tableData": [
    ["Best Wedding Car Rental in Mumbai", "Wedding Car Hire Mumbai"],
    ["Mumbai Wedding Car Service", "Mumbai Wedding Limo Rental"],
    ["Luxury Wedding Car Rental Mumbai", "Wedding Car Booking Mumbai"],
    ["Wedding Car Rental Packages Mumbai", "Mumbai Wedding Car Booking"],
    ["Wedding Car for Rent in Mumbai"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Luxurious and Elegant Fleet",
      "WhyChoosedescription": "At Vedant Travels, we offer a stunning range of luxury cars that are perfect for your wedding day. From classic cars to modern luxury sedans, SUVs, and limousines, our fleet is designed to match the grandeur and elegance of your special day."
    },
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "We understand the importance of timing on your wedding day. Our professional drivers ensure that you and your loved ones arrive at your wedding venue, reception, or other locations on time. We offer prompt pickups and smooth transitions, so you can focus on enjoying your day."
    },
    {
      "WhyChooseheading": "Experienced and Professional Chauffeurs",
      "WhyChoosedescription": "Our chauffeurs are highly experienced, well-trained, and dressed in professional attire to ensure that you feel pampered and well taken care of. They are courteous, knowledgeable, and will provide you with a comfortable, safe, and luxurious ride to your wedding events."
    },
    {
      "WhyChooseheading": "Customizable Packages",
      "WhyChoosedescription": "We offer flexible and customizable wedding car rental packages. Whether you need a car for the bride and groom, wedding party transportation, or a luxury ride for your guests, we tailor our services to meet your specific requirements."
    },
    {
      "WhyChooseheading": "Decorations and Personalization",
      "WhyChoosedescription": "To add a special touch to your wedding day, we offer car decoration services. You can choose from a range of decorative styles, including flowers, ribbons, and other personal touches, to make your ride as beautiful as the occasion itself."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "At Vedant Travels, we provide transparent pricing with no hidden charges. We offer competitive rates for our wedding car rentals, so you can enjoy luxury without breaking the bank. We make sure you know exactly what you’re paying for upfront."
    },
    {
      "WhyChooseheading": "Wide Range of Vehicles to Choose From",
      "WhyChoosedescription": "Whether you’re looking for a vintage car, a modern luxury sedan, a stretch limousine, or a classic convertible, we have something for every couple’s preference. Choose the vehicle that best fits your style and needs for your big day."
    },
    {
      "WhyChooseheading": "Stress-Free Booking Process",
      "WhyChoosedescription": "Booking your wedding car rental with Vedant Travels is easy and hassle-free. You can book online via our website or mobile app, or call our customer service team for personalized assistance. We’ll ensure everything is perfectly arranged for your wedding day."
    }
  ]
    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a wedding car rental in Mumbai with Vedant Travels?',
            answer: 'You can book your wedding car rental online through our website or mobile app. Alternatively, you can call our customer service team for help with your booking.',
        },
        {
            id: 2,
            question: 'What types of wedding cars are available for rent?',
            answer: 'We offer a variety of wedding cars, including luxury sedans, SUVs, vintage cars, limousines, and more. All vehicles are well-maintained and equipped to provide a comfortable, luxurious ride.',
        },
        {
            id: 3,
            question: 'Do you offer wedding car decoration services?',
            answer: 'Yes, we provide decoration services for the wedding car. You can choose from a variety of decorative options, including flowers, ribbons, and personalized touches to make your ride extra special.',
        },
        {
            id: 4,
            question: 'How do I pay for my wedding car rental in Mumbai?',
            answer: 'We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app. Payment is made simple and secure for your convenience.',
        },
        {
            id: 5,
            question: 'Are there any additional charges for wedding car rental services?',
            answer: 'There are no hidden charges. Our pricing is transparent, and any extra costs, such as waiting time or additional services, will be communicated clearly before the booking is confirmed.',
        },
        {
            id: 6,
            question: 'Can I hire a car for the entire wedding day?',
            answer: 'Yes, we offer full-day rental packages for wedding cars. Whether you need the car for the entire day or just for specific events (such as the ceremony and reception), we will customize the package according to your needs.',
        },
        {
            id: 7,
            question: 'Can I rent a luxury car for my wedding guests?',
            answer: 'Yes, we can arrange luxury transportation for your wedding guests. Whether you need transport for the bridal party or other attendees, we offer convenient and comfortable vehicles.',
        },
        {
            id: 8,
            question: 'What is the booking process like for a wedding car rental?',
            answer: 'The booking process is simple and quick. You can choose your vehicle, select the date and time, and confirm the booking online or with our customer service team. We ensure that everything is ready for your special day.',
        },
        {
            id: 9,
            question: 'Do you offer services for pre-wedding events or photo shoots?',
            answer: 'Yes, we can provide wedding cars for pre-wedding events or photo shoots. Whether you need a luxury car for an engagement ceremony or a bridal photo shoot, we have the perfect vehicle to enhance your experience.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for my wedding car rental?',
            answer: 'Vedant Travels offers a luxurious and stress-free experience for your wedding day. With our wide selection of vehicles, experienced chauffeurs, customizable packages, and transparent pricing, we ensure that your special day is nothing short of perfect.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Rajesh and Mrs. Priya Patel",
            title: "Wedding Couple",
            quote: "The wedding car we rented from Vedant Travels was absolutely perfect! The driver was professional, and the car was beautifully decorated. It was an elegant and comfortable ride for us on our big day. Highly recommend!",
            rating: 5,
        },
        {
            name: "Mr. Sameer Desai",
            title: "Wedding Client",
            quote: "We rented a luxury sedan for our wedding, and it was a fantastic experience. The vehicle was spotless, and the chauffeur was very courteous. Vedant Travels made our wedding transportation worry-free!",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   

  
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Best Wedding Car Rental in Mumbai",
  "image": "https://vedanttravels.in/assets/images/best-wedding-car-rental-mumbai.jpg",
  "description": "Book the best wedding car rental in Mumbai with Vedant Travels. Choose from luxury sedans, SUVs, and classic cars to make your special day memorable with stylish and reliable transportation.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1500"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "9999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/best-wedding-car-rental-mumbai"
  }
};



  


    return (
        <div>
             <Helmet>
  <title>Best Wedding Car Rental in Mumbai | Luxury & Classic Cars | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book the best wedding car rental in Mumbai with Vedant Travels. Choose from luxury sedans, SUVs, and classic cars to make your special day memorable with stylish and reliable transportation." 
  />
  <meta 
    name="keywords" 
    content="Best Wedding Car Rental in Mumbai, Wedding Car Hire Mumbai, Luxury Wedding Cars Mumbai, Vedant Travels Wedding Cars, Classic Wedding Car Rental Mumbai, Stylish Wedding Car Mumbai, Reliable Wedding Car Rental Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/92.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Bestweddingcarrentalinmumbai;